// Keep aligned with crm/contract_field_assignments.py. Generic legacy signers
// fill customer fields, never salesperson/manager fields.
const roleAliases = [
  ['customer', 'client', 'homeowner', 'buyer', 'signer'],
  ['sales_rep', 'sales', 'representative', 'salesperson', 'sales_representative', 'sales representative', 'salesrep'],
  ['manager', 'supervisor'],
];

export function fieldBelongsToRecipient(
  field: { signer?: string },
  recipient: { role?: string; email?: string },
): boolean {
  const role = (recipient.role || 'signer').trim().toLowerCase();
  const email = (recipient.email || '').trim().toLowerCase();
  if (!email || role === 'cc' || role === 'approver') return false;
  const signer = (field.signer || 'customer').trim().toLowerCase();
  return signer === email || (roleAliases.find(group => group.includes(role)) || [role]).includes(signer);
}
